import { setUID } from "../../redux/userSlice";
import { store } from "../../store/store";
import { subScribeToAuthStateChange } from "../firebase";
import { setAdminLoggerUserId } from "../../utils/logging/FrontendLoggerFactory";

/**
 * CRITICAL: Auth <-> Store Synchronization
 *
 * This logic was moved here from firebase.ts to break a circular dependency.
 *
 * The cycle was:
 * firebase.ts -> store -> baseApi -> MemoizedAuth -> firebase.ts
 *
 * resulting in: Uncaught ReferenceError: Cannot access 'auth' before initialization
 *
 * DO NOT move this logic back to firebase.ts.
 */
export const initAuthStoreSync = () => {
    subScribeToAuthStateChange(user => {
        const nextUid = user?.uid ?? "";
        store.dispatch(setUID(nextUid));
        setAdminLoggerUserId(nextUid || undefined);
    });
};
